module.exports = __webpack_public_path__ + "static/media/q_nav_4_not_selected.2a208bd1.svg";